import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/async';
import ModalTrigger from '../common/ModalTrigger';
import { putRequest } from '../../requestUtils';
import './DeclineProposal.scss';

const cannotRejectProposal = (internalFeedbacks, rejectionText, userType) => (
  (userType === 'clora_rep'
    && (internalFeedbacks.length === 0
    || (internalFeedbacks && internalFeedbacks.map((r) => r.label).includes('Other') && rejectionText === '')))
  || (userType !== 'clora_rep' && rejectionText === '')
);

class DeclineProposal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reason: '',
      internalFeedbacks: '',
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSelectReason = this.handleSelectReason.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange(name, value) {
    this.setState({
      [name]: value,
    });
  }

  handleSelectReason(option) {
    const { internalFeedbacks } = this.state;

    if (internalFeedbacks && internalFeedbacks.find((i) => i.value === option.value)) {
      const existing = internalFeedbacks.find((i) => i.value === option.value);
      internalFeedbacks.splice(internalFeedbacks.indexOf(existing), 1);
      this.setState({ internalFeedbacks });
    } else if (internalFeedbacks) {
      this.setState({ internalFeedbacks: [...internalFeedbacks, option] });
    } else {
      this.setState({ internalFeedbacks: [option] });
    }
  }

  handleSubmit() {
    const {
      formUrl, csrfToken, handleProposalAfterSubmit, showNewProposalUX,
    } = this.props;
    const { internalFeedbacks } = this.state;

    const data = {
      reason: this.state.reason,
      internal_feedback_ids: internalFeedbacks && internalFeedbacks.map((r) => r.value),
    };

    return putRequest(
      formUrl,
      data,
      csrfToken,
    ).then((res) => {
      if (showNewProposalUX) {
        handleProposalAfterSubmit(res.data);
      } else {
        window.location.reload();
      }
    }).catch((err) => {
      this.setState({ errors: err });
    });
  }

  renderTextArea(placeholder) {
    return (
      <textarea
        value={this.state.reason}
        className="form-control"
        placeholder={placeholder}
        name="reason"
        id="reason"
        rows="4"
        onChange={(val) => this.handleInputChange('reason', val.target.value)}
      />
    );
  }

  renderContent() {
    const { userType, consultantName, feedbackOptions } = this.props;
    const { internalFeedbacks } = this.state;

    if (userType === 'clora_rep') {
      return (
        <div className="decline-proposal-modal style-guide">
          <h2 className="mb-3">
            Decline
            {consultantName}
            &#39;s proposal
          </h2>
          <p className="body-text-2 mb-3">
            Why was
            &nbsp;
            {consultantName}
            &nbsp;
            not the right fit?
            &nbsp;
            <strong>
              This will not be sent to
              the Consultant.
            </strong>
          </p>
          <div className="mb-2">
            <AsyncSelect
              className="rejection-dropdown"
              classNamePrefix="rejection-reason"
              loadOptions={() => new Promise((resolve) => { resolve(feedbackOptions); })}
              defaultOptions
              value={internalFeedbacks}
              maxMenuHeight={500}
              onChange={(val) => this.handleInputChange('internalFeedbacks', val)}
              closeOnSelect={false}
              closeMenuOnSelect={false}
              isMulti
              cacheOptions
            />
          </div>
          {this.renderTextArea('Enter a rejection reason...')}
        </div>
      );
    }

    return (
      <div className="decline-proposal-modal style-guide">
        <h2 className="mb-8">
          Decline
          {consultantName}
          &#39;s proposal
        </h2>
        <p className="body-text-2 mb-3">
          Why is
          &nbsp;
          {consultantName}
          &nbsp;
          not a good fit?
          Select all that didn&apos;t meet your expectations.
          &nbsp;
          <strong>
            Only Clora will see
            your feedback.
          </strong>
        </p>

        <div className="mb-2 d-flex flex-wrap gap-3">
          { (feedbackOptions || []).map((option) => (
            <button
              className={
                `btn-choice"
                  ${internalFeedbacks
                      && internalFeedbacks.find((f) => (f && f.value === option.value))
                  ? 'selected' : ''}`
              }
              onClick={() => this.handleSelectReason(option)}
            >
              { option.label }
            </button>
          ))}
        </div>

        {this.renderTextArea('Please provide more details here so we can find the best candidates.')}
      </div>
    );
  }

  render() {
    const { triggerType, userType, buttonStyles } = this.props;
    const { internalFeedbacks, reason } = this.state;

    return (
      <ModalTrigger
        triggerText="Decline"
        buttonStyles={buttonStyles}
        submitButtonText={userType === 'clora_rep' ? 'Yes, Decline' : 'Decline Proposal'}
        submitButtonStyle="danger"
        cancelButtonText="No, Cancel"
        cancelButton={userType === 'clora_rep'}
        handleSubmit={this.handleSubmit}
        submitDisabled={cannotRejectProposal(internalFeedbacks, reason, userType)}
        triggerType={triggerType}
        idKey="decline-proposal-modal"
        closeAfterSubmit
      >
        {this.renderContent()}
      </ModalTrigger>
    );
  }
}

DeclineProposal.propTypes = {
  formUrl: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  triggerType: PropTypes.string,
  userType: PropTypes.string,
  consultantName: PropTypes.string.isRequired,
  feedbackOptions: PropTypes.arrayOf(PropTypes.shape({})),
  buttonStyles: PropTypes.string,
  handleProposalAfterSubmit: PropTypes.func,
  showNewProposalUX: PropTypes.bool,
};

DeclineProposal.defaultProps = {
  triggerType: 'button',
  userType: 'employer',
  feedbackOptions: [],
  buttonStyles: 'danger',
  handleProposalAfterSubmit: () => {},
  showNewProposalUX: false,
};

export default DeclineProposal;
